import { usePathname, useRouter, useSearchParams } from 'next/navigation';

const garminPermissionsKey = 'garminPermissions';
const garminPermissionsReturnKey = 'garmin_permissions_return';
const garminNewConnectionKey = 'new_garmin_connection';

const useRemoveQueryParam = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const router = useRouter();

  const removeQueryParam = (key: string) => {
    const updatedSearchParams = new URLSearchParams(searchParams.toString());
    updatedSearchParams.delete(key);

    router.push(`${pathname}?${updatedSearchParams.toString()}`);
  };

  return removeQueryParam;
};

export { garminPermissionsKey, garminPermissionsReturnKey, garminNewConnectionKey, useRemoveQueryParam };
